import { AppSettings } from "../constants/AppSettings";

/**
 * This app will run in a Docker container, and we want to be able to change the API base URL after building an image,
 * so we attempt to read it from the config file served by the same server as the UI5 application.
 */
export async function GetContainerConfig(): Promise<ContainerConfig | null> {
  const response = await fetch("config.json");

  if (!response.ok) {
    console.error("Failed to load config.json");
    return null;
  }
  return response.json();
}

export interface ContainerConfig {
  apiBaseUrl: string;
}

export async function GetApiBaseUrl() {
  // const config = await GetContainerConfig();
  // return config?.apiBaseUrl || AppSettings.apiBaseUrl;
  return AppSettings.apiBaseUrl;
}
